// Helper function to parse and extract main image URL from imageUrls JSON string
export const parseImageUrls = (imageUrlsString: string) => {
  try {
    // Handle null, undefined, or empty string
    if (!imageUrlsString) {
      return {
        imageUrls: {},
        mainImageUrl: null,
      };
    }

    const imageUrls = JSON.parse(imageUrlsString);

    // Try multiple possible keys for the main image
    const mainImageUrl =
      imageUrls.main ||
      imageUrls.front ||
      imageUrls.primary ||
      imageUrls.default ||
      Object.values(imageUrls)[0] ||
      null;

    return {
      imageUrls,
      mainImageUrl,
    };
  } catch (error) {
    console.error('Error parsing image URLs:', imageUrlsString, error);
    return {
      imageUrls: {},
      mainImageUrl: null,
    };
  }
};